/**
 * 字符串脱敏处理
 * @param {String} 字符串对象
 * @param {Number} 保留开头几位字符
 * @param {Number} 保留结尾几位字符
 */
export function truncateString(data, left=4, right=3) {
  const length = data?.trim()?.length || 0
    if (!data || !length)
        return ''

    if (length === 1)
        return data[0] + '*'.repeat(length)

    if (length <= left)
        return data[0] + '*'.repeat(length - 1)

    if (length <= left + right)
        return data[0] + '*'.repeat(length - 2) + data[length - 1]

    return data.slice(0, left) + '*'.repeat(length - left - right) + data.slice(length - right)
}